export default {
  // Tabs
  otcTrading: "OTC Trading",
  depositWithdrawTrading: "Deposit/Withdraw Trading",
  userBehavior: "User Behavior",
  accountBalance: "Account Balance",
  walletBalance: "Wallet Balance",
  loginDeviceInfo: "Login/Device Info",
  deliveryInfo: "Delivery Info",
  paymentMethodRecord: "Payment Method Record",

  // Message prompts
  alreadyCurrentPage: "Already current details page!",
};
